
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSwiper } from '../hooks/useSwiper';
import FsLightbox from "fslightbox-react";
import BlogSidebar from './BlogSidebar';
import { useTranslation } from 'react-i18next';

const BlogDetailsSec = ({ post }) => {
    const { t } = useTranslation();
    const swiperRef = useSwiper();
    const [toggler, setToggler] = useState(false);

    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage(t('sections.blogDetailsSec.comment_thanks','✅ Thanks for commenting! Please wait for admin approval.'));
        e.target.reset();
    };

    // Fallback if no post is provided
    if (!post) {
        return (
            <section className="ot-blog-wrapper blog-details position-relative overflow-hidden space-top space-extra-bottom overflow-hidden">
                <div className="container">
                    <div className="text-center py-5">
                        <h2>{t('sections.blogDetailsSec.not_found','Blog post not found')}</h2>
                        <Link to="/blog" className="ot-btn mt-4">{t('sections.blogDetailsSec.back_to_blog','Back to Blog')}</Link>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className="ot-blog-wrapper blog-details position-relative overflow-hidden space-top space-extra-bottom overflow-hidden">
                <div className="bg-gradient-shape1" />
                <div className="bg-gradient-shape1 bg-gradient-shape2" />
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-8 col-lg-7">
                            <div className="ot-blog blog-single" data-cue="slideInUp">
                                {post.postType === 'normal' && (
                                    <div className="blog-img">
                                        <Link to={`/blog/${post.slug}`}>
                                            <img src={post.detailImage} alt={post.title} />
                                        </Link>
                                    </div>
                                )}
            
                                {post.postType === 'video' && (
                                    <div className="blog-img">
                                        <Link to={`/blog/${post.slug}`}>
                                            <img src={post.detailImage} alt={post.title} />
                                        </Link>
                                        <a 
                                            href="#"
                                            onClick={(e) => {
                                            e.preventDefault();
                                            setToggler(!toggler);
                                            }}
                                            className="play-btn"
                                        >
                                            <i className="fas fa-play"></i>
                                        </a>
                                        
                                        <FsLightbox
                                            toggler={toggler}
                                            sources={[post.videoUrl]}
                                        />
                                    </div>
                                )}
            
                                {post.postType === 'gallery' && (
                                    <div className="blog-img">
                                        <div ref={swiperRef} className="ot-react-slider" data-slider-options='{"effect":"fade"}'>
                                            <div className="swiper-wrapper">
                                                {post.detailImage && post.detailImage.map((img, idx) => (
                                                    <div key={idx} className="swiper-slide" data-opacity="5" data-overlay="black">
                                                        <Link to={`/blog/${post.slug}`}>
                                                            <img src={img} alt={post.title} />
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                            <button className="slider-arrow slider-prev"><i className="far fa-angle-left" /></button>
                                            <button className="slider-arrow slider-next"><i className="far fa-angle-right" /></button>
                                        </div>
                                    </div>
                                )}
                                <div className="blog-content">
                                        <div className="blog-meta">
                                        <Link className="author" to="/blog">
                                            <i className="fas fa-user" />
                                            {t('sections.blogMain.by','BY')} {post.author}
                                        </Link>
                                        <Link to="/blog">
                                            <i className="fas fa-calendar-days" />
                                            {post.date}
                                        </Link>
                                    </div>

                                    <h2 className="blog-title">
                                        {post.titleKey ? t(post.titleKey, post.title) : post.title}
                                    </h2>
                                    <p>
                                        {post.content.introKey ? t(post.content.introKey, post.content.intro) : post.content.intro}
                                    </p>
                                    <p>
                                        {post.content.mainContentKey ? t(post.content.mainContentKey, post.content.mainContent) : post.content.mainContent}
                                    </p>
                                    {post.content.quote && (
                                        <blockquote>
                                            <p>
                                                "{post.content.quote.textKey ? t(post.content.quote.textKey, post.content.quote.text) : post.content.quote.text}"
                                            </p>
                                            <cite>{post.content.quote.authorKey ? t(post.content.quote.authorKey, post.content.quote.author) : post.content.quote.author}</cite>
                                            <span className="desig">{post.content.quote.designationKey ? t(post.content.quote.designationKey, post.content.quote.designation) : post.content.quote.designation}</span>
                                        </blockquote>
                                    )}
                                    <p className="mb-30">
                                        {post.content.middleContentKey ? t(post.content.middleContentKey, post.content.middleContent) : post.content.middleContent}
                                    </p>
                                    <div className="row mt-15">
                                        <div className="col-md-6 mb-35">
                                            <img
                                                className="w-100 rounded-20"
                                                src="assets/img/blog/blog_inner_1.jpg"
                                                alt={t('sections.blogDetailsSec.inner_image_alt','Blog Post')}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-35">
                                            <img
                                                className="w-100 rounded-20"
                                                src="assets/img/blog/blog_inner_2.jpg"
                                                alt={t('sections.blogDetailsSec.inner_image_alt','Blog Post')}
                                            />
                                        </div>
                                    </div>
                                    <p className="mb-n2">
                                        {post.content.conclusionKey ? t(post.content.conclusionKey, post.content.conclusion) : post.content.conclusion}
                                    </p>
                                    <div className="share-links clearfix ">
                                        <div className="row justify-content-between">
                                            <div className="col-sm-auto">
                                                <span className="share-links-title">{t('sections.blogDetailsSec.tags','Tags:')}</span>
                                                <div className="tagcloud">
                                                    {post.tags.map((tag, index) => (
                                                        <Link key={index} to={`/blog?tag=${tag.toLowerCase().replace(/\s+/g, '-')}`}>
                                                            {tag}
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="col-sm-auto text-xl-end">
                                                <span className="share-links-title">{t('sections.blogDetailsSec.share','Share:')}</span>
                                                <div className="ot-social style2">
                                                    <a href="https://www.facebook.com/">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                    <a href="https://www.twitter.com/">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                    <a href="https://www.linkedin.com/">
                                                        <i className="fab fa-linkedin-in" />
                                                    </a>
                                                    <a href="https://www.youtube.com/">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ot-comments-wrap ">
                                <h2 className="blog-inner-title h4">
                                    <i className="fas fa-comments" /> {t('sections.blogDetailsSec.comments_with_count','Comments (03)')}
                                </h2>
                                <ul className="comment-list">
                                    <li className="ot-comment-item">
                                        <div className="ot-post-comment">
                                            <div className="comment-avater">
                                                <img
                                                    src="assets/img/blog/comment-author-1.jpg"
                                                    alt={t('sections.blogDetailsSec.comment_author_alt','Comment Author')}
                                                />
                                            </div>
                                            <div className="comment-content">
                                                <h3 className="name">{t('sections.blogDetailsSec.comment_author_1','Michel Smith')}</h3>
                                                <span className="commented-on">{t('sections.blogDetailsSec.comment_date_1','24 Dec, 2024 04:20pm')}</span>
                                                <p className="text">
                                                    {t('sections.blogDetailsSec.comment_text_1',"Secur's service was excellent! They handled my cybersecurity needs efficiently, with great customer support.")}
                                                </p>
                                                <div className="reply_and_edit">
                                                    <button type="button" className="reply-btn">
                                                        <i className="fas fa-reply" /> {t('sections.blogDetailsSec.reply','Reply')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <ul className="children">
                                            <li className="ot-comment-item">
                                                <div className="ot-post-comment">
                                                    <div className="comment-avater">
                                                        <img
                                                            src="assets/img/blog/comment-author-2.jpg"
                                                            alt={t('sections.blogDetailsSec.comment_author_alt','Comment Author')}
                                                        />
                                                    </div>
                                                    <div className="comment-content">
                                                        <h3 className="name">{t('sections.blogDetailsSec.comment_author_2','Sarah Rahman')}</h3>
                                                        <span className="commented-on">{t('sections.blogDetailsSec.comment_date_2','24 Dec, 2024 04:20pm')}</span>
                                                        <p className="text">
                                                            {t('sections.blogDetailsSec.comment_text_2',"Secur's service was outstanding! They provided reliable cybersecurity with quick, excellent support.")}
                                                        </p>
                                                        <div className="reply_and_edit">
                                                            <button type="button" className="reply-btn">
                                                                <i className="fas fa-reply" /> {t('sections.blogDetailsSec.reply','Reply')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li className="ot-comment-item">
                                        <div className="ot-post-comment">
                                            <div className="comment-avater">
                                                        <img
                                                            src="assets/img/blog/comment-author-3.jpg"
                                                            alt={t('sections.blogDetailsSec.comment_author_alt','Comment Author')}
                                                        />
                                            </div>
                                            <div className="comment-content">
                                                <h3 className="name">{t('sections.blogDetailsSec.comment_author_3','William John')}</h3>
                                                <span className="commented-on">{t('sections.blogDetailsSec.comment_date_3','24 Dec, 2024 04:20pm')}</span>
                                                <p className="text">
                                                    {t('sections.blogDetailsSec.comment_text_3',"Secur ensured robust cybersecurity with quick, professional support every step of the way.")}
                                                </p>
                                                <div className="reply_and_edit">
                                                    <button type="button" className="reply-btn">
                                                        <i className="fas fa-reply" /> {t('sections.blogDetailsSec.reply','Reply')}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="ot-comment-form">
                                <div className="form-title">
                                    <h3 className="blog-inner-title h4 mb-2">{t('sections.blogDetailsSec.leave_reply','Leave Reply')}</h3>
                                    <p className="form-text">
                                        {t('sections.blogDetailsSec.form_text',"Email won't be shared. Required fields are marked *.")}
                                    </p>
                                </div>

                                {message && (
                                    <div className="alert alert-success mb-4">
                                        {message}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <input
                                                type="text"
                                                placeholder={t('sections.blogDetailsSec.placeholder.name','Your Name*')}
                                                className="form-control"
                                                required
                                            />
                                            <i className="far fa-user" />
                                        </div>

                                        <div className="col-md-6 form-group">
                                            <input
                                                type="email"
                                                placeholder={t('sections.blogDetailsSec.placeholder.email','Your Email*')}
                                                className="form-control"
                                                required
                                            />
                                            <i className="far fa-envelope" />
                                        </div>

                                        <div className="col-12 form-group">
                                            <textarea
                                                placeholder={t('sections.blogDetailsSec.placeholder.comment','Write a Comment*')}
                                                className="form-control"
                                                required
                                            />
                                            <i className="far fa-pencil" />
                                        </div>

                                        <div className="col-12 form-group mb-0">
                                            <button type="submit" className="ot-btn btn-fw">
                                                {t('sections.blogDetailsSec.submit','Submit Now')} <i className="far fa-long-arrow-right ms-2" />
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <div className="col-xxl-4 col-lg-4 sidebar-wrap">
                            <BlogSidebar />
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default BlogDetailsSec;